module.exports = __webpack_public_path__ + "./fonts/RobotoCondensed-Bold.ttf";